import type { INotification } from '$src/types/notifications.type';
import { writable } from 'svelte/store';

// notifications
export const notificationsStore = writable<INotification[]>([]);
export const notificationsUnreadStore = writable<number>(0);
